// extracted by mini-css-extract-plugin
export default {"layout":"Terms_layout__J6bvj","start":"Terms_start__WmjF7","markdown":"Terms_markdown__gKgW5","examples":"Terms_examples__-G8g-"};